import React, { type FC } from 'react';
import { Spinner } from '../Spinner';
import './LoadingOverlay.scss';

interface LoadingOverlayProps {
    show: boolean;
}

export const LoadingOverlay: FC<LoadingOverlayProps> = ({ show }) => {
    if (!show) return null;

    return (
        <div className="loading-overlay" aria-hidden>
            <Spinner />
        </div>
    );
};
